import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BulkCompanyUserEntity } from '../../domain/entities/BulkCompanyUserEntity'

export class BulkCompanyUserModel extends BulkCompanyUserEntity {
  constructor(dataDto: BulkCompanyUserEntity) {
    super()
    mapEntityProperties<BulkCompanyUserModel>(this, dataDto,{
        exclude: ['users'],
        map: {
          users: dataDto.users?.map((user) => ({
            userId: user.user?.id,
            mealTierId: user.mealTier?.id,
            maxItemPerMeal: user.maxItemPerMeal ?? null
          }))
        }
      }
    )
  }
}
